import React from "react";
import { paper, serif } from "./docTheme.js";
import { visibleCrm } from "./crmBlock.js";

const fmt = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "");

// "Contacts & outreach" in the meeting document (CRM spec 2026-11-03). `crm` is computeCrm()
// output. Read-only it renders exactly what the client sees (visibleCrm); while editing it also
// offers per-entry Hide, Show all, and hiding the whole block from the client.
export default function CrmSection({ meeting, crm, editable, busy, btn, onSave }) {
  const state = meeting.crm || { hidden: false, hiddenEventIds: [], rev: 0 };
  const block = visibleCrm(crm, editable ? { ...meeting, crm: { ...state, hidden: false } } : meeting);
  if (!block) return null;
  const hiddenCount = crm?.hiddenCount || 0;
  const tiles = [["contacts", block.counts.contacts], ["leads", block.counts.lead], ["in progress", block.counts.inProgress], ["won", block.counts.won]];
  return (
    <section style={{ padding: "40px 0", borderBottom: `1px solid ${paper.line}`, display: "flex", flexDirection: "column", gap: 16, opacity: state.hidden ? 0.55 : 1 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <h2 style={{ margin: 0, fontFamily: serif, fontWeight: 600, fontSize: 30, flex: 1 }}>Contacts &amp; outreach</h2>
        {editable && (state.hidden
          ? <><span style={{ fontSize: 13, color: paper.muted }}>Hidden from client ·</span>
            <button type="button" style={btn} disabled={busy} onClick={() => onSave({ hidden: false })} aria-label="Show contacts & outreach to client">Show</button></>
          : <button type="button" style={btn} disabled={busy} onClick={() => onSave({ hidden: true })} aria-label="Hide contacts & outreach from client">Hide section</button>)}
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, minmax(0, 1fr))", gap: 16 }}>
        {tiles.map(([label, value]) => (
          <div key={label} style={{ background: paper.card, border: `1px solid ${paper.line}`, borderRadius: 12, padding: 18, display: "flex", flexDirection: "column", gap: 2 }}>
            <span style={{ fontFamily: serif, fontSize: 34, fontWeight: 600 }}>{value}</span>
            <span style={{ fontSize: 13, color: paper.muted }}>{label}</span>
          </div>
        ))}
      </div>
      {editable && hiddenCount > 0 && (
        <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: paper.muted }}>
          <span>Hidden entries: {hiddenCount} ·</span>
          <button type="button" style={{ ...btn, padding: "2px 8px", fontSize: 12 }} disabled={busy} onClick={() => onSave({ hiddenEventIds: [] })} aria-label="Show all outreach entries">Show all</button>
        </div>
      )}
      {block.events.length > 0 && (
        <div>
          <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: "uppercase", color: paper.muted, marginBottom: 6 }}>What’s new</div>
          {block.events.map((e) => (
            <div key={e.id} style={{ display: "flex", gap: 12, padding: "12px 0", borderTop: `1px solid ${paper.lineSoft}` }}>
              <div style={{ flex: 1, fontSize: 15, lineHeight: 1.5 }}>
                <div style={{ fontWeight: 700 }}>{e.headline}</div>
                {(e.detail || e.date) && <div style={{ fontSize: 13, color: paper.muted }}>{[e.detail, fmt(e.date)].filter(Boolean).join(" · ")}</div>}
                {e.text && <div style={{ whiteSpace: "pre-wrap", marginTop: 4 }}>{e.text}</div>}
              </div>
              {editable && <button type="button" style={{ ...btn, alignSelf: "flex-start" }} disabled={busy}
                onClick={() => onSave({ hiddenEventIds: [...(state.hiddenEventIds || []), e.id] })} aria-label={`Hide entry ${e.headline}`}>Hide</button>}
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
